import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Polls the count of unread internal-messaging conversations for the current user.
export default function useUnreadMessages(intervalMs = 15000) {
  const { user } = useAuth();
  const [count, setCount] = useState(0);
  const load = useCallback(() => {
    if (!user) { setCount(0); return; }
    api.get("/conversations/unread-count").then((r) => setCount(r.data?.count || 0)).catch(() => {});
  }, [user]);
  useEffect(() => { load(); const t = setInterval(load, intervalMs); return () => clearInterval(t); }, [load, intervalMs]);
  return count;
}
